import { render, staticRenderFns } from "./OrderComplaintTable.vue?vue&type=template&id=38e90a68&scoped=true&"
import script from "./OrderComplaintTable.vue?vue&type=script&lang=js&"
export * from "./OrderComplaintTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderComplaintTable.vue?vue&type=style&index=0&id=38e90a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e90a68",
  null
  
)

export default component.exports